<template>
  <div class="app-router">
    <h2 class="font-weight-bold pb-5">
      Data Pembelian Produk Reseller
      <div class="text-caption">Berikut ini adalah ringkasan informasi Pembelian Produk Reseller</div>
    </h2>

    <v-row class="mb-5">
      <v-col cols="12" class="pt-0">
        <v-btn color="black" class="white--text" @click="gotoPembelianForm()" v-show="false">
          <span class="text-subtitle-2 text-capitalize font-weight-bold">
            <v-icon left>mdi-plus</v-icon>Beli Produk
            Reseller
          </span>
        </v-btn>
      </v-col>
      <v-col cols="12" class="pt-0">
        <router-link to="/seller/pembelian/tambah-v3">
          <v-btn color="success" dark>
            <span class="text-subtitle-2 text-capitalize font-weight-bold">
              <v-icon left>mdi-plus</v-icon>Beli Produk
              Reseller
            </span>
          </v-btn>
        </router-link>
      </v-col>
    </v-row>

    <v-card outlined class="px-3 py-3">
      <v-tabs slider-color="black" color="black" grow show-arrows v-model="intabs">
        <v-tab class="text-caption font-weight-bold">Semua</v-tab>
        <template v-for="(status, idx) in filterStatus(statusPembelian)">
          <v-tab class="text-caption font-weight-bold" :key="idx">
            {{ statusCaption(status.po_status) }}
            <v-chip
              small
              class="mx-2"
              color="black"
              text-color="white"
              v-if="status.count_status > 0"
            >{{ status.count_status }}</v-chip>
          </v-tab>
        </template>

        <v-tab-item>
          <poData :allowedStatus="allowedStatus" v-if="intabs === 0"></poData>
        </v-tab-item>

        <template v-for="(status, idlist) in filterStatus(statusPembelian)">
          <v-tab-item :key="idlist">
            <poData :allowedStatus="[status.po_status]" v-if="intabs === (idlist + 1)"></poData>
          </v-tab-item>
        </template>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import poData from "./components/pembelianData";

export default {
  components: {
    poData
  },
  data() {
    return {
      intabs: null,
      status: [],
      allowedStatus: [
        "created",
        "pending",
        "paid",
        "pickup",
        "delivery",
        "processed",
        "completed",
        "rejected",
        "cancel",
      ]
    };
  },
  computed: {
    ...mapState("pembelianSeller", ["statusPembelian"])
  },
  methods: {
    ...mapActions("pembelianSeller", ["getStatusPembelian"]),

    statusCaption(status) {
      if (status === "created") return "Pembelian Baru";
      else if (status === "pending") return "Menunggu Verifikasi";
      else if (status === "paid") return "Pembayaran Disetujui";
      else if (status === "processed") return "Sedang Diproses";
      else if (status === "pickup") return "Permintaan Pickup/Drop Off";
      else if (status === "delivery") return "Sedang Diantar";
      else if (status === "completed") return "Sudah Selesai";
      else if (status === "rejected") return "Dibatalkan Admin";
      else if (status === "cancel") return "Dibatalkan Pembeli";
    },

    filterStatus(data) {
      if (data) {
        let showStatus = data.filter(d =>
          this.allowedStatus.includes(d.po_status)
        );
        return showStatus;
      }
    },

    gotoPembelianForm() {
      this.$router.push({
        name: "seller-tambah-pembelian"
      });
    }
  },
  async created() {
    this.$store.dispatch("setPageTitle", `Daftar Pembelian`);
    await this.getStatusPembelian();
  }
};
</script>